import { render, staticRenderFns } from "./Start.vue?vue&type=template&id=e750b006&"
import script from "./Start.vue?vue&type=script&lang=ts&"
export * from "./Start.vue?vue&type=script&lang=ts&"
import style0 from "./Start.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports